import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ded4db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "contrast" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "tr" }
const _hoisted_5 = { class: "th compare" }
const _hoisted_6 = { class: "th" }
const _hoisted_7 = { class: "priceName" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "円/月", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "th" }
const _hoisted_13 = { class: "priceName" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "円/月", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "topB" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottomB" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftB" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightB" }, null, -1))
const _hoisted_23 = { class: "body" }
const _hoisted_24 = { class: "thead" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "tbody" }
const _hoisted_27 = { class: "td" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = {
  key: 0,
  class: "card-des"
}
const _hoisted_33 = {
  key: 1,
  class: "card-des"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "card-item-title" }
const _hoisted_36 = { class: "card-item-content" }
const _hoisted_37 = { class: "card1" }
const _hoisted_38 = { class: "card-title" }
const _hoisted_39 = { class: "card-des whitespace-pre-wrap" }
const _hoisted_40 = { class: "linkUrl" }
const _hoisted_41 = {
  key: 1,
  class: "card2"
}
const _hoisted_42 = { class: "card-title" }
const _hoisted_43 = { class: "question" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "card3" }
const _hoisted_46 = { class: "card-title" }
const _hoisted_47 = {
  class: "card-des",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_48 = { class: "flex-cen" }

import { computed } from 'vue'
import { t } from '@/plugins/i18n'
import { isEN, isJA, isKO, useSite, isMember } from '@/store'
import { CardItem } from './MemberTabs.vue'
import { formatMoney } from '@/plugins/utils'
import { useStore } from 'vuex'
import bus from '@/util/useBus'

type ValueType = string | boolean | [boolean, string]
interface PersonCompareProps<T> {
  img: string
  title: string
  list: { cate: string, left: T, right: T }[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    memberTab: { type: String, required: true },
    contrast: { type: Array, required: true }
  },
  emits: ['changeTab', 'open'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  memberTab: 'person' | 'company'
  contrast: CardItem[]
}
const jumpContact = () => {
  if (isJA()) {
    window.open('https://www.theckb.com/contact/')
  }
  if (isKO()) {
    window.open(' https://center-pf.kakao.com/_uzWxoxj')
  }
  if (isEN()) {
    bus.emit('open-chat')
  }

}





const store = useStore()
const templateLevel = computed(() => {
  return store.getters.membership?.templateLevel ?? 0
})

const jump = () => {
  emits('changeTab')
  document.getElementsByClassName('member_tabCard')[0]!.scrollIntoView()
}

/** 去首页 */
const goHome = () => {
  location.href = '/hub/ec'
}

const renderVal = (val: string | boolean | [boolean, string]) => {
  if (typeof val === 'boolean') {
    return `<img style='width:24px;vertical-align: bottom;' src='${val ? 'https://static-s.theckb.com/BusinessMarket/member/member_true.png' : 'https://static-s.theckb.com/BusinessMarket/member/member_false.png'}' />`
  }
  if (val instanceof Array) {
    return `<div >
    <img style='width:24px;vertical-align: middle;'  src='${val[0] ? 'https://static-s.theckb.com/BusinessMarket/member/member_true.png' : 'https://static-s.theckb.com/BusinessMarket/member/member_false.png'}'/>
    <span style="color:#8C8C8C">${t(val[1])}</span>
    </div>`
  }
  return `<span style="color:#8C8C8C">${t(val)}</span>`
}

const cardInfo1 = [
  {
    icon: 'https://static-s.theckb.com/BusinessMarket/member/card1_icon1.png',
    title: '免手续费和采购次数无限制',
    content: '可无限次采购 EC 网站商品，免手续费，降低采购成本，最大化利润率。'
  }, {
    icon: 'https://static-s.theckb.com/BusinessMarket/member/card1_icon2.png',
    title: '独特产品开发和竞争差异化',
    content: '批发商专属商品和品牌代理销售，加上简单 OEM 支持，帮助您与竞争对手区别开来，强化自有品牌。'
  }, {
    icon: 'https://static-s.theckb.com/BusinessMarket/member/card1_icon3.png',
    title: '过代发货实现业务自动化',
    content: '与日本电商网站（如 Amazon、BASE、Shopify 等）系统联动，无需库存管理，实现业务自动化。通过自动同步商品信息和自动订单处理，大大节省时间和精力。'
  }
]

const cardInfo2 = [{
  icon: 'https://static-s.theckb.com/BusinessMarket/member/card2_icon1.png',
  title: '高效管理，减轻工作负担',
  content: '商务会员最多支持10家店铺，头等会员则可不限店铺数量使用！通过优化采购到销售的业务流程，帮助您以更少的精力扩大业务。'
}, {
  icon: 'https://static-s.theckb.com/BusinessMarket/member/card2_icon2.png',
  title: '专业支持体系',
  content: '提供在线聊天支持，以及由专业负责人提供的Chatwork支持，确保高效、快速的业务运营。'
}, {
  icon: 'https://static-s.theckb.com/BusinessMarket/member/card2_icon3.png',
  title: '全面支持品牌成长',
  content: '通过OEM/ODM的全面支持，轻松开发定制商品或自主品牌。品牌独占销售权和优惠价格商品助力差异化竞争，提升品牌价值。'
}, {
  icon: 'https://static-s.theckb.com/BusinessMarket/member/card2_icon4.png',
  title: '1对1特别商品提案',
  content: '根据您的品牌和需求，专属采购员1对1推荐特殊商品。此外，每月可免费获得⚪︎万日元以内的样品，帮助您在低风险下把握市场机会。'
}]

const card2Tips = computed(() => {
  return {
    person: {
      title: '面向法人的收费计划',
      des: '我们不仅提供个体经营者，也为法人提供收费计划。提供 OEM 和 ODM 支持及周末客户服务，选择适合您业务规模和需求的最佳计划',
      linkTitle: '法人和企业客户请点此 >',
      tab: 'company'
    },
    company: {
      title: '个人及个体户的收费计划',
      des: '我们还为个体户和个人用户提供会员计划。适合业务起步阶段的新人或希望尝试新挑战的人群，助力他们迈向更高的业务台阶。',
      linkTitle: '个人用户请点击此处 >',
      linkUrl: 'person'
    }
  }[props.memberTab]
})
console.log(card2Tips.value, 'card2Tips')

const questions = computed(() => {
  return {
    person: {
      ja: [{
        q: '業務輸入目的ではなく、個人輸入目的でサービスを利用することは可能ですか？',
        a: 'はい。法人・個人事業主・個人問わず、大口・小口、卸売・仕入れ・個人利用など幅広く対応しています。'
      }, {
        q: '初心者ですが、操作方法やマニュアルなどありますか？',
        a: 'はい、初心者の方でも安心してご利用いただけるよう、操作方法のガイドやマニュアルをご用意しております(<a href="https://s.theckb.com/ja/help">https://s.theckb.com/ja/help</a>)。また、スタンダード会員以上のプランでは、チャットサポートやLINEを通じてリアルタイムでサポートを受けることも可能です。'
      }, {
        q: '会員プランの料金の支払い方法について教えてください。',
        a: `支払い方法は下記の3種類をご利用いただけます。
・現金振り込み
・クレジットカード
・paypal
※銀行振込の際の手数料はお客様負担となります。クレジットカードおよびPayPalご利用時には3.4%の手数料がかかります。また、初回のお支払い時のみ、クレジットカードの登録が必要です。
`
      }, {
        q: '無料プランから有料プランへの変更は簡単ですか？',
        a: 'はい、マイページから数クリックでプランのアップグレードが可能です。アップグレード後、すぐに有料プランの特典が利用できるようになります。'
      }, {
        q: '一時的に利用を停止し、後で再開したい場合はどうしたら良いですか？',
        a: '会員自動払いを「OFF」に設定し、PayPal自動払いも解除してください。有効期限が切れた際は【未入会】状態になり、再度の利用には会員費用をお支払いいただく必要があります。'
      }, {
        q: '最低利用期間や解約手数料のルールは？',
        a: '最低利用期間は特に設けておりませんが、途中解約の場合でも月額料金は日割りされませんのでご了承ください。'
      }],
      en: [],
      ko: []
    },
    company: {
      ja: [{
        q: '複数アカウント管理は可能ですか？',
        a: 'はい、ビジネス会員プランでは最大10アカウント、ファースト会員プランではアカウント数無制限でご利用いただけます。'
      }, {
        q: 'OEM・ODMの具体的な対応内容について教えてください。',
        a: 'OEM・ODMに関しては、商品デザインのカスタマイズ、パッケージング、専用タグの作成、さらに商品付属品の追加など、幅広く対応しています。詳細については、カスタマーサポートにご相談ください。'
      }, {
        q: '会員プランの料金の支払い方法について教えてください。',
        a: `支払い方法は下記の3種類をご利用いただけます。
・現金振り込み
・クレジットカード
・paypal
※銀行振込の際の手数料はお客様負担となります。クレジットカードおよびPayPalご利用時には3.4%の手数料がかかります。また、初回のお支払い時のみ、クレジットカードの登録が必要です。
`
      }, {
        q: '途中で会員プランを変更することはできますか？',
        a: 'はい、プランのアップグレードやダウングレードはいつでも可能です。ダウングレードは現在のプラン有効期間終了後に適用されます。'
      }, {
        q: '一時的に利用を停止し、後で再開したい場合はどうしたら良いですか？',
        a: '会員自動払いを「OFF」に設定し、PayPal自動払いも解除してください。有効期限が切れた際は【未入会】状態になり、再度の利用には会員費用をお支払いいただく必要があります。'
      }, {
        q: '最低利用期間や解約手数料のルールは？',
        a: '最低利用期間は特に設けておりませんが、途中解約の場合でも月額料金は日割りされませんのでご了承ください。'
      }],
      en: [],
      ko: []
    }
  }[props.memberTab][useSite()]
})

// purchase: [
//   '无限制', [true, '每件手续费5元'], true, '在线聊天和 LINE 专属支持'
// ],
//   brand: [[true, '现有产品简单 OEM 和辅料 OEM'], [true, '具备销售许可'], true, true, [true, '每月2次']],
//     efficiency: [false, '每天三次']

const personCompare: PersonCompareProps<ValueType>[] = [
  {
    img: 'https://static-s.theckb.com/BusinessMarket/member/contrast1.png',
    title: '采购业务',
    list: [
      { cate: '中国 EC 网站（淘宝、1688、TMALL 等）商品采购', left: true, right: true },
      // { cate: '批发市场商品采购', left: false, right: [true, '每件手续费5元'] },
      { cate: '日本标准质检服务', left: true, right: true },
      { cate: '客服支持', left: '仅限在线聊天', right: '系统聊天和 LINE 专属支持' }]

  },
  {
    img: 'https://static-s.theckb.com/BusinessMarket/member/contrast2.png',
    title: '品牌化扶持',
    list: [
      { cate: 'OEM 和 ODM', left: false, right: [true, '现有产品简单 OEM 和辅料 OEM'] },
      { cate: '中国和韩国品牌代理', left: false, right: [true, '具备销售许可'] },
      { cate: '自定义附加项和辅料使用', left: false, right: true },
      { cate: 'KAERU MEDIA（进口知识、新产品信息等）', left: true, right: true },
      { cate: 'Line 特别推荐商品（线下商品和优质商品）', left: false, right: [true, '2次/月2'] }]
  }, {
    img: 'https://static-s.theckb.com/BusinessMarket/member/contrast3.png',
    title: '效率化扶持（API 联动和便捷工具）',
    list: [
      { cate: 'D2C代发货（与 base/shopify/stores 等 API 联动和自动订单处理）', left: false, right: true },
      { cate: 'KAERU 工具（日语搜索和类似画像搜索）', left: true, right: true },
      { cate: '成本计算工具', left: true, right: true }]
  }
]

const companyCompare: PersonCompareProps<ValueType>[] = [
  {
    img: 'https://static-s.theckb.com/BusinessMarket/member/contrast4.png',
    title: '基本手续费',
    list: [
      { cate: '采购手续费（市場购商品）', left: '4元/点', right: '3元/点' },
      { cate: '次品自动再次购买（市場购商品）', left: '7元/点', right: '6元/点' },
      { cate: 'OEM采样费用', left: '50元/回', right: '45元/回' }]
  }, {
    img: 'https://static-s.theckb.com/BusinessMarket/member/contrast5.png',
    title: '検品附加项',
    list: [
      { cate: '去布标・去水洗标・去吊牌', left: '0.8元/点', right: '0.5元/点' },
      { cate: '制作并缝制水洗标', left: '4.8元/点', right: '2.5元/点' },
      { cate: '缝布标', left: '5元/点', right: '2元/点' }]
  }, {
    img: 'https://static-s.theckb.com/BusinessMarket/member/contrast6.png',
    title: '发货附加项',
    list: [
      { cate: '贴标2', left: '0.8元/点', right: '0.5元/点' },
      { cate: '普通发货袋', left: '0.5元/点', right: '無料' }
    ]
  }
]


return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.memberTab === 'person' ? _unref(t)('免费与标准会员的比较') : _unref(t)('商务舱和头等舱的比较')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(__props.contrast[0]?.combo?.priceName ?? ''), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_unref(formatMoney)(__props.contrast[0]?.combo.discountActualPrice)), 1),
                    _hoisted_9
                  ]),
                  (__props.memberTab === 'person')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "btn purchase",
                        onClick: goHome
                      }, _toDisplayString(_unref(t)('开始采购')), 1))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["btn", `level${__props.contrast[0]?.combo.templateLevel}`]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('open', __props.contrast[0]?.combo)))
                      }, [
                        (_unref(templateLevel) === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('立即入会')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(templateLevel) === __props.contrast[0]?.combo.templateLevel ? _unref(t)('去续费') : _unref(t)('去开通')), 1))
                      ], 2))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(__props.contrast[1]?.combo?.priceName ?? ''), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref(formatMoney)(__props.contrast[1]?.combo.discountActualPrice)), 1),
                    _hoisted_15
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn", `level${__props.contrast[1]?.combo.templateLevel}`]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('open', __props.contrast[1]?.combo)))
                  }, [
                    (_unref(templateLevel) === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('立即入会')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(templateLevel) === __props.contrast[1]?.combo.templateLevel ? _unref(t)('去续费') : _unref(t)('去开通')), 1))
                  ], 2),
                  (_unref(isJA)() && __props.memberTab === 'person' && _unref(templateLevel) < 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_18, [
                          (!_unref(isMember)())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " 🔥 " + _toDisplayString(_unref(t)('推荐')) + " 🔥 ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.memberTab === 'person' ? personCompare : companyCompare), (person, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("img", {
                      class: "img",
                      src: person.img,
                      alt: ""
                    }, null, 8, _hoisted_25),
                    _createTextVNode(" " + _toDisplayString(_unref(t)(person.title)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.list, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "tr",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)(item.cate)), 1),
                        _createElementVNode("div", {
                          class: "td value",
                          innerHTML: renderVal(item.left)
                        }, null, 8, _hoisted_28),
                        _createElementVNode("div", {
                          class: "td value",
                          innerHTML: renderVal(item.right)
                        }, null, 8, _hoisted_29)
                      ]))
                    }), 128))
                  ])
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, _toDisplayString(__props.memberTab === 'person' ? _unref(t)('成为标准会员的三大优势') : _unref(t)('企业会员计划的四大优势')), 1),
      (__props.memberTab === 'person')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(t)('作为标准会员，您将享受加速业务发展的三大主要优势：节省成本、差异化竞争和独特的产品开发。')), 1))
        : _createCommentVNode("", true),
      (__props.memberTab === 'company')
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(t)('商务会员和头等会员提供个人计划无法享受的特别支持和丰富特权，为业务扩展和增长提供助力。以下是三个主要优势，请根据需求选择适合您的计划。')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["card-info", __props.memberTab])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.memberTab === 'person' ? cardInfo1 : cardInfo2).filter(v => _unref(t)(v.title)), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card-item",
            key: index
          }, [
            _createElementVNode("img", {
              class: "icon",
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_34),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)(item.title)), 1),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)(item.content)), 1)
          ]))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)(_unref(card2Tips).title)), 1),
      _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)(_unref(card2Tips).des)), 1),
      _createElementVNode("div", {
        class: "flex-cen",
        onClick: jump
      }, [
        _createElementVNode("a", _hoisted_40, _toDisplayString(_unref(t)(_unref(card2Tips).linkTitle)), 1)
      ])
    ]),
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('常见的问题')), 1),
          _createVNode(_component_el_collapse, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questions), (item, idx) => {
                return (_openBlock(), _createBlock(_component_el_collapse_item, {
                  key: idx,
                  name: idx
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_43, _toDisplayString(idx + 1) + ". " + _toDisplayString(_unref(t)(item.q)), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("pre", {
                      class: "answer",
                      style: {"white-space":"pre-wrap"},
                      innerHTML: item.a
                    }, null, 8, _hoisted_44)
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('免费咨询2')), 1),
      _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('若对选择合适的计划有疑问，请随时联系我们。THECKB（直行便）的专业人员将根据您的业务需求为您提供免费咨询。')), 1),
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_ElButton, {
          style: {"color":"#fff","margin-top":"32px"},
          color: "#0586FE",
          size: "large",
          round: "",
          onClick: jumpContact
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('免费咨询')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})